import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/2026/speakers/detail-page-top-shard.png")